import { useMutation, useQuery } from '@apollo/client';
import { useCustomSnackbar } from '@procureai/ui-mui';
import { useCallback, useMemo } from 'react';

import { toLineItemSchemaData } from '../IntakeRequestLineItemStep/IntakeRequestLineItemStep.util';
import { useChatSession } from '~/modules';

import { FormSubmitData } from './components/IntakeRequestComplexStepForm';
import { INTAKE_REQUEST_COMPLEX_STEP_NEXT_MUTATION } from './IntakeRequestComplexStep.mutation.gql';
import { INTAKE_REQUEST_COMPLEX } from './IntakeRequestComplexStep.query.gql';
import { toFormSchemaData, toGraphqlFormat } from './IntakeRequestComplexStep.utils';

export const useComplexStep = () => {
  const session = useChatSession();
  const { onError } = useCustomSnackbar();

  const { data: queriedData } = useQuery(INTAKE_REQUEST_COMPLEX, {
    variables: session,
  });

  const [next, { loading }] = useMutation(INTAKE_REQUEST_COMPLEX_STEP_NEXT_MUTATION, {
    refetchQueries: [INTAKE_REQUEST_COMPLEX],
    onError,
  });

  const data = useMemo(
    () => ({
      ...toFormSchemaData(
        queriedData?.sevenbridges.chatSession.request,
        queriedData?.sevenbridges.chatSession.requestDescription?.text,
      ),
      lineItems: toLineItemSchemaData(queriedData?.sevenbridges.chatSession.request?.lineItems),
      commodityGroupId: queriedData?.sevenbridges.chatSession.request?.commodityGroupId,
    }),
    [queriedData],
  );

  const submit = useCallback(
    async (formData: FormSubmitData) => {
      await next({
        variables: toGraphqlFormat(session.id, formData),
      });
    },
    [next, session.id],
  );

  return {
    submit,
    isSubmitting: loading,
    data,
  };
};
